import React, { FC } from "react";
import BaseTerms from "components/front/term/BaseTerms";
import AnimeFurusatoTerms from "components/front/term/AnimeFurusatoTerms";
import CorpAnimeFurusatoTerms from "components/front/term/CorpAnimeFurusatoTerms";
import AnimeShoppingTerms from "components/front/term/AnimeShoppingTerms";
import DocumentSection from "components/front/layout/DocumentSection";

export type Props = {};
const TermSection: FC<Props> = () => (
  <DocumentSection>
    <BaseTerms />
    <AnimeFurusatoTerms />
    <CorpAnimeFurusatoTerms />
    <AnimeShoppingTerms/>
    <section>
      <p>以上</p>
      <ul>
        <li>2020年10月30日 制定</li>
        <li>2021年09月30日 改定</li>
        <li>2022年09月09日 改定</li>
        <li>2024年02月25日 改定</li>
      </ul>
    </section>
  </DocumentSection>
);
export default TermSection;
